import React from 'react';
import ManagementLayout from '../layout/ManagementLayout';
import Card from '../common/Card';
import Badge from '../common/Badge';
import useAuth from '../../auth/useAuth';

export default function Settings() {
  const { user, customer, logout } = useAuth();

  return (
    <ManagementLayout>
      <div className="mol-page">
        <div className="mol-page__header">
          <div>
            <h2 className="mol-page__title">Settings</h2>
            <p className="mol-page__subtitle">Your profile and account settings.</p>
          </div>
        </div>

        <div className="mol-settings-grid">
          <Card className="mol-settings-card">
            <h3 className="mol-settings-card__title">Profile Information</h3>
            <div className="mol-settings-card__row">
              <span className="mol-settings-card__label">Name</span>
              <span className="mol-settings-card__value">{user?.name || '—'}</span>
            </div>
            <div className="mol-settings-card__row">
              <span className="mol-settings-card__label">Email</span>
              <span className="mol-settings-card__value">{user?.email || '—'}</span>
            </div>
            <div className="mol-settings-card__row">
              <span className="mol-settings-card__label">Role</span>
              <Badge variant={user?.role === 'admin' ? 'primary' : user?.role === 'manager' ? 'success' : 'default'}>
                {user?.role || '—'}
              </Badge>
            </div>
          </Card>

          <Card className="mol-settings-card">
            <h3 className="mol-settings-card__title">Account Information</h3>
            <div className="mol-settings-card__row">
              <span className="mol-settings-card__label">Customer / Account</span>
              <span className="mol-settings-card__value">{customer?.name || '—'}</span>
            </div>
            <div className="mol-settings-card__row">
              <span className="mol-settings-card__label">Account Status</span>
              <Badge variant={customer?.status === 'active' ? 'success' : 'default'}>
                {customer?.status || '—'}
              </Badge>
            </div>
            <div className="mol-settings-card__row">
              <span className="mol-settings-card__label">Storage Location</span>
              <span className="mol-settings-card__value mol-settings-card__value--muted">
                Customer media folder (managed by MYORGLAB)
              </span>
            </div>
          </Card>

          <Card className="mol-settings-card">
            <h3 className="mol-settings-card__title">Preferences</h3>
            <div className="mol-settings-card__row">
              <span className="mol-settings-card__label">Notifications</span>
              <span className="mol-settings-card__value">Email notifications enabled</span>
            </div>
            <div className="mol-settings-card__row">
              <span className="mol-settings-card__label">Display</span>
              <span className="mol-settings-card__value">Light mode</span>
            </div>
          </Card>

          <Card className="mol-settings-card">
            <h3 className="mol-settings-card__title">Session</h3>
            <p className="mol-text-muted" style={{ marginBottom: '16px' }}>
              Sign out of your MYORGLAB Media Console session.
            </p>
            <button className="mol-btn mol-btn--secondary" onClick={logout}>
              Sign Out
            </button>
          </Card>
        </div>
      </div>
    </ManagementLayout>
  );
}
